import React from 'react'
import Switch from 'react-switch'
import { colors } from 'Constants'

export default props => (
  <Switch onColor={colors.green} uncheckedIcon={false} checkedIcon={false} {...props} />
)
